import dayjs from 'dayjs';

export const dateFormatChange = (dateFormat, useUkTimeZone = false) => {
  if (useUkTimeZone) {
    const localeDate = new Date(dateFormat).toLocaleDateString('en-GB', { timeZone: 'Europe/London' });
    const localeTime = new Date(dateFormat).toLocaleTimeString('en-GB', { timeZone: 'Europe/London' }).split(':');
    return localeDate + ' ' + localeTime[0] + ':' + localeTime[1];
  }

  const localeDate = dateFormat.split('T');
  const dateTimeFormatOnly = localeDate[0].split('-');
  const timeFormatOnly = localeDate[1].split(':');
  return (
    dateTimeFormatOnly[2] +
    '/' +
    dateTimeFormatOnly[1] +
    '/' +
    dateTimeFormatOnly[0] +
    ' ' +
    timeFormatOnly[0] +
    ':' +
    timeFormatOnly[1]
  );
};

export const getDateFilter = (date, isEndOfDay = false) => {
  // returns a formatted date for use in search filters
  let newDate;
  if (isEndOfDay) {
    newDate = dayjs(date).set('hour', 23).set('minute', 59).set('second', 59);
  } else {
    newDate = dayjs(date).set('hour', 0).set('minute', 0).set('second', 0);
  }
  return newDate;
};
